<template>
  <v-card class="rsl-fixed-height">
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('CASES.TASKS.TEAM_TASKS_SEARCH_TEXT')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="teamTasks"
      :items-per-page="25"
      :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
      :item-class="setRowStyle"
      :search="search"
      class="elevation-1 mx-3 mb-3"
      item-key="id"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      loading-text="Loading... Please wait"
      :loading="loading"
    >
      <template slot="item.actions" slot-scope="row">
        <v-btn v-if="currentRole != 'userRole'"
          small
          class="mr-2"
          color="secondary"
          @click="viewProcessMap(row.item)"
        >
          {{ $t('CASES.TASKS.BTNS.MAP') }}
        </v-btn>
        <v-btn v-if="row.item.assignee == null"
          small
          class="mr-2"
          color="success"
          @click="claimTask(row.item)"
        >
          {{ $t('CASES.TASKS.BTNS.CLAIM') }}
        </v-btn>
        <v-btn
          small
          class="mr-2"
          color="warning"
          @click="reassignTask(row.item)"
        >
          {{ $t('CASES.TASKS.BTNS.REASSIGN') }}
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="claim"
        :retain-focus="false"
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ claimTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ claimText }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="claim = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmClaim({taskId})"
            >{{ $t('CASES.TASKS.BTNS.CLAIM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="reassignDialog"
        :retain-focus="false"
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ reassignTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ reassignText }}</div>
            <div class="pt-5">{{ userText }}</div>

            <div class="pt-5">{{ $t('CASES.TASKS.REASSIGN_TEXT_3') }}</div>
            <v-autocomplete
              v-model="value"
              :items="reassignList"
              item-text="name"
              item-value="val"
            ></v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="reassignDialog = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmReassign({value})"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="1000"
        v-model="processMapDialog"
        :retain-focus="false"
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ processMapTitle }}
            <v-spacer></v-spacer>
            <v-btn
              small
              class="mr-2"
              color="secondary"
              @click="closeProcessMap()"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
          </v-toolbar>
          <v-card-text>
            <div id="canvas" class="canvas"></div>
          </v-card-text>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="taskInfoDialog"
        :retain-focus="false"
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ taskInfoTitle }}
            <v-spacer></v-spacer>
            <v-btn
              small
              class="mr-2"
              color="secondary"
              @click="closeTaskInfo()"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
          </v-toolbar>
          <v-card-text>
            <div class="pt-5" v-html="taskInfoDetails"></div>
          </v-card-text>
        </v-card>
      </template>
    </v-dialog>

  </v-card>
</template>

<script>
  import $ from 'jquery';
  import NavViewer from '../assets/process-builder/lib/NavViewer';
  import { mapGetters } from 'vuex';
  export default {
    name: 'teamtasks',
    computed: {
      ...mapGetters(['teamTasks', 'usersGroups', 'teamMembers', 'reassignList', 'candidateGroups', 'candidateUsers', 'teamTasksFollowUpIds', 'teamTasksOverdueIds', 'processMap', 'activityInstance']),
    },
    data: function() {
      return {
        loading: false,
        currentRole: this.$store.state.currentRole,
        claim: false,
        claimTitle: '',
        claimText: '',
        reassignDialog: false,
        reassignTitle: '',
        reassignText: '',
        userText: '',
        taskId: '',
        value: null,
        search: '',
        sortBy: '',
        sortDesc: false,
        theCurrentUser: '',
        theTaskName: '',
        theCaseId: 0,
        theProcessName: '',
        theProcessInstanceId: '',
        processMapDialog: false,
        processMapTitle: '',
        taskInfoDialog: false,
        taskInfoTitle: '',
        taskInfoDetails: '',
        viewer: null,
        headers: [
          {
            text: this.$t('CASES.FIELDS.CASE_ID'),
            align: 'start',
            sortable: true,
            value: 'caseId',
          },
          { text: this.$t('CASES.FIELDS.CASE_LABEL'), sortable: true, value: 'caseLabel' },
          { text: this.$t('CASES.FIELDS.TASK_NAME'), value: 'name' },
          { text: this.$t('CASES.FIELDS.PROCESS_NAME'), value: 'processName' },
          { text: this.$t('CASES.FIELDS.CREATED_ON'), value: 'created', sortable: false },
          { text: this.$t('CASES.FIELDS.FOLLOW_UP_DATE'), value: 'followUp', sortable: false },
          { text: this.$t('CASES.FIELDS.DUE_DATE'), value: 'due', sortable: false },
          { text: this.$t('CASES.FIELDS.ASSIGNED_TO'), value: 'assignee' },
          { text: this.$t('CASES.FIELDS.ACTIONS'), value: 'actions', sortable: false }
        ]
      }
    },
    created() {
      this.unsubscribe = this.$store.subscribe((mutation) => {

        if(mutation.type === 'PROCESS_MAP') {
          this.processMapTitle = this.$t('CASES.TASKS.MAP_TEXT') + ' ' + this.theCaseId + ' (' + this.theProcessName + ')';
          this.processMapDialog = true;
          let canvas = document.getElementById('canvas');
          this.viewer = new NavViewer({ 
            container: canvas
          });

          this.viewer.importXML(this.processMap).then( () => {
            this.viewer.attachTo('#canvas');
            this.viewer.get('canvas').zoom('fit-viewport');
          });
        }

        if(mutation.type === 'ACTIVITY_INSTANCE') {
          for(let i = 0; i < this.activityInstance.length; i++) {
            let ref = this;
            let target = '[data-element-id="' + this.activityInstance[i].activityId + '"]';
            let el = document.querySelector(target);

            if(this.activityInstance[i].endTime) {
              el.classList.add('rsl-completed');
            }

            if(!this.activityInstance[i].endTime) {
              el.classList.add('rsl-current');
            }

            el.addEventListener('click', function() {
              let taskInfo = {
                'activityId': ref.activityInstance[i].activityId,
                'activityName': ref.activityInstance[i].activityName,
                'assignee': ref.activityInstance[i].assignee,
                'startTime': ref.activityInstance[i].startTime,
                'endTime': ref.activityInstance[i].endTime
              };

              ref.showTaskInfo(taskInfo);
            });
          }
        }

      });
      this.refreshTasks();
    },
    beforeDestroy() {
      this.unsubscribe();
    },
    methods: {
      setRowStyle(item) {
        let classes = '';

        if(this.teamTasksOverdueIds.indexOf(item.processInstanceId) != -1) {
          classes += ' error--text';
        }else {
          if(this.teamTasksFollowUpIds.indexOf(item.processInstanceId) != -1) {
            classes += ' warning--text';
          }
        }

        return classes;
      },
      refreshTasks() {
        this.loading = true;
        this.$store.dispatch('getUsersGroups').then( () => {
          this.$store.dispatch('getTeamMembers').then( () => {
            let groups = '';
            for(let i = 0; i < this.usersGroups.length; i++) {
              groups = groups + this.usersGroups[i].id + ','
            }
            groups = groups.replace(/,\s*$/, "");

            let members = '';
            for(let j = 0; j < this.teamMembers.length; j++) {
              if(this.teamMembers[j].id !== this.$store.state.currentUser) {
                members = members + this.teamMembers[j].id + ','
              }
            }
            members = members.replace(/,\s*$/, "");

            let payload = {
              'groups': groups,
              'members': members
            }

            this.$store.dispatch('getTeamTasks', payload).then( () => {
              this.loading = false;
              // Apply sort field and order
              let field = this.$store.state.teamTasksSortField;
              let sort = this.$store.state.teamTasksSortOrder;
              if(field == null) {
                this.sortBy = 'caseId';
                this.sortDesc = true;
              }else if (sort == 'none') {
                this.sortBy = '';
                this.sortDesc = false;
              }else {
                this.sortBy = field;

                if(sort == 'descending') {
                  this.sortDesc = true;
                }else {
                  this.sortDesc = false;
                }
              }
              // Remove previous click events
              $('.text-start.sortable').off();
              // Add new click events for storing order
              let ref = this;
              $('.text-start.sortable').click(function() {
                let column = $(this)[0].firstChild.innerHTML;
                let order = $(this).attr('aria-sort');
                
                for(let i = 0; i < ref.headers.length; i++) {
                  if(column == ref.headers[i].text) {
                    ref.$store.commit('setTeamTasksSortField', ref.headers[i].value);
                    ref.$store.commit('setTeamTasksSortOrder', order);
                  }
                }
              });
            });
          });
        });
      },
      viewProcessMap(item) {
        this.theProcessName = item.processName;
        this.theCaseId = item.caseId;
        this.$store.dispatch('getProcessMap', item.processDefinitionId).then( () => {
          this.$store.dispatch('getInstanceActivity', item.processInstanceId);
        });
      },
      closeProcessMap() {
        let canvas = document.getElementById('canvas');
        canvas.innerHTML = '';
        this.processMapDialog = false;
      },
      showTaskInfo(taskInfo) {
        let startTime = this.$t('CASES.TASKS.TASK_INFO.NO_START');
        let endTime = this.$t('CASES.TASKS.TASK_INFO.NO_END');
        let assignee = this.$t('CASES.TASKS.TASK_INFO.NO_ASSIGN');

        // Format start/end times
        if(taskInfo.startTime) {
          let st = new Date(taskInfo.startTime);
          startTime = new Intl.DateTimeFormat('en-GB', 
            {
              day: 'numeric',
              month: 'numeric', 
              year: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
              hour12: false
            }).format(st);
        }

        if(taskInfo.endTime) {
          let et = new Date(taskInfo.endTime);
          endTime = new Intl.DateTimeFormat('en-GB', 
            {
              day: 'numeric',
              month: 'numeric', 
              year: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
              hour12: false
            }).format(et);
        }

        if(taskInfo.assignee) {
          assignee = taskInfo.assignee;
        }

        this.taskInfoTitle = this.$t('CASES.TASKS.TASK_INFO.TITLE');
        this.taskInfoDetails = '<p>' + this.$t('CASES.FIELDS.TASK_ID') + ': ' + taskInfo.activityId + '</p>';
        this.taskInfoDetails += '<p>' + this.$t('CASES.FIELDS.TASK_NAME') + ': ' + taskInfo.activityName + '</p>';
        this.taskInfoDetails += '<p>' + this.$t('CASES.FIELDS.ASSIGNED_TO') + ': ' + assignee + '</p>';
        this.taskInfoDetails += '<p>' + this.$t('CASES.TASKS.TASK_INFO.TASK_START') + ': ' + startTime + '</p>';
        this.taskInfoDetails += '<p>' + this.$t('CASES.TASKS.TASK_INFO.TASK_END') + ': ' + endTime + '</p>';
        this.taskInfoDialog = true;
      },
      closeTaskInfo() {
        this.taskInfoDialog = false;
      },
      claimTask(item) {
        this.claimTitle = this.$t('CASES.TASKS.CLAIM_TASK.TITLE');
        this.claimText = this.$t('CASES.TASKS.CLAIM_TASK.DESC') + ' ' + item.name;
        this.taskId = item.id;
        this.claim = true;
      },
      confirmClaim(item) {
        this.claim = false;
        let payload = {
          'taskId': item.taskId,
          'userId': this.$store.state.currentUser
        }
        this.$store.dispatch('claimTask', payload).then( () => {
          this.refreshTasks();
        });
      },
      async reassignTask(item) {
        let assignedTo = item.assignee;
        if(assignedTo == null) {
          assignedTo = this.$t('CASES.TASKS.TASK_INFO.NO_ASSIGN');
        }

        this.theCurrentUser = assignedTo;
        this.theTaskName = item.name;
        this.theCaseId = item.caseId;
        this.theProcessName = item.processName;
        this.theProcessInstanceId = item.processInstanceId;

        await this.$store.dispatch('getCandidateGroups', item.id).then( async () => {
          let payload = {
            'groupIds': this.candidateGroups,
            'userIds': this.candidateUsers,
            'assignedTo': assignedTo
          }
          await this.$store.dispatch('getReassignUserList', payload).then( () => {
            this.reassignTitle = this.$t('CASES.TASKS.REASSIGN_TITLE');
            this.reassignText = this.$t('CASES.TASKS.REASSIGN_TEXT_1') + ' ' + item.name;
            this.userText = this.$t('CASES.TASKS.REASSIGN_TEXT_2') + ' ' + assignedTo;
            this.taskId = item.id;
            this.reassignDialog = true;
          });
        });
      },
      confirmReassign(item) {
        this.reassignDialog = false;

        let payload = {
          'taskId': this.taskId,
          'userId': item.value
        }
        this.$store.dispatch('reassignTask', payload).then( () => {
          this.updateLog('Task', 'Reassigned', this.theCaseId, this.theProcessName, this.theTaskName, 'Task ' + this.theTaskName + ' reassigned from ' + this.theCurrentUser + ' to ' + item.value + '.');

          let payload = {
            'instanceId': this.theProcessInstanceId,
            'opened': false,
            'caseId': this.theCaseId,
            'taskId': this.taskId,
            'assignee': item.value
          };
          this.$store.dispatch('updateAssignee', payload);

          this.refreshTasks();
        });
      },
      updateLog(cat, op, caseId, process, task, msg) {
        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        if(caseId == null) {
          caseId = 0;
        }

        let logData = {
          'category': cat,
          'userId': this.$store.state.currentUser,
          'caseId': caseId,
          'processName': process,
          'taskName': task,
          'operation': op,
          'msg': msg,
          'dateTime': dateTime,
        };
        this.$store.dispatch('updateOpLog', logData);
      }
    }
  }
</script>

<style>
  .rsl-completed > .djs-visual > rect {
    stroke: #4caf50 !important;
    stroke-width: 5px !important;
  }
  .rsl-current > .djs-visual > rect {
    stroke: #1976d2 !important;
    stroke-width: 5px !important;
  }
</style>